<div class="broken-page-dialog">
  <div class="text-and-buttons-column">
    <div class="text-row">
      <h2>{{ "broken-page.title" | translate }}</h2>
      <p>{{ "broken-page.description" | translate }}</p>
    </div>
    <div class="buttons-row">
      <button class="primary-button" mat-stroked-button (click)="reloadCurrentPage()">
        <mat-icon>refresh</mat-icon>
        <span class="btn-label">{{ "broken-page.reload-page" | translate | uppercase }}</span>
      </button>
      <button class="secondary-button" mat-stroked-button (click)="goToStartPage()">
        <mat-icon>arrow_back</mat-icon>
        <span class="btn-label">{{ "broken-page.back-to-start" | translate | uppercase }}</span>
      </button>
    </div>
  </div>
  <div class="image-column">
    <img mat-card-image src="/assets/img/bee_fallen.png" alt="bee_fallen" />
  </div>
</div>
